import React from 'react';
import { ResponsivePieCanvas } from '@nivo/pie';
import { colors } from './styles';

export const ChartPie = props => (
  <ResponsivePieCanvas
    margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
    pixelRatio={2}
    innerRadius={0.5}
    padAngle={0.7}
    cornerRadius={3}
    colors={colors}
    borderColor={{ from: 'color', modifiers: [['darker', 0.6]] }}
    radialLabelsSkipAngle={10}
    radialLabelsTextXOffset={6}
    radialLabelsTextColor="#333333"
    radialLabelsLinkOffset={0}
    radialLabelsLinkDiagonalLength={16}
    radialLabelsLinkHorizontalLength={24}
    radialLabelsLinkStrokeWidth={1}
    radialLabelsLinkColor={{ from: 'color' }}
    slicesLabelsSkipAngle={10}
    slicesLabelsTextColor="#333333"
    animate={false}
    {...props}
  />
);

export default ChartPie;
